declare global {
  interface Window {
    sendEvent: (payload: EventPayload | PageViewPayload | CustomData | UpptackaEventPayload) => void;
  }
}

interface EventData {
  label?: string;
  action?: string;
}

interface EventPayload {
  event_category: string;
  event_action: string;
  event_label: string;
  custom?: object;
}

interface UpptackaEventPayload {
  label?: string;
  action?: string;
  event_action: string;
  custom: { ref_app: string; store_id: string;}
  event_category?:string;
}

interface CustomData {
  name: string;
  params: object;
}

interface PageViewPayload {
  // event_category: string;
  page_path: string;
  page_location: string;
  custom?: object;
}

function analyticsApiClient(actionName: string) {
  const categoryName = 'self_serve_actions';

  const sendAnalyticsEvent = (
    payload: EventPayload | PageViewPayload | CustomData | UpptackaEventPayload
  ): void => {
    if (window && window.sendEvent) {
      console.log("send event payload for google analytics", payload);
      window.sendEvent(payload);
    }
  };

  /**
   * Sends a regular labeled event.
   * @param {object} data – The log settings.
   * @param {string} data.label – The event label.
   * @param {string} [data.action] – Optional event action. Defauls
   * to the actionName provided on instantiation.
   * @param {Object} [custom] Optional param containing additional data.
   */
  const sendEvent = (
    data: EventData | UpptackaEventPayload,
    custom?: object,
    eventName?: string
  ): void => {
    const eventCategory = eventName || categoryName;
    const payload: UpptackaEventPayload | EventPayload = (data.label === 'store_details') ? {
      event_action: 'event_action' in data ? (data as UpptackaEventPayload).event_action : '',
      custom: 'custom' in data ? (data as UpptackaEventPayload).custom : { ref_app: '',store_id:'' },
    } : {
      event_category: eventCategory,
      event_label: typeof data.label === 'string' ? data.label : '',
      event_action: typeof data.action === 'string' ? data.action : actionName,
    };

    if (custom && Object.keys(custom).length > 0) {
      payload.custom = custom;
    }

    sendAnalyticsEvent(payload);
  };

  /**
   * Sends an error
   * @param {string} error The error-message.
   */
  const sendError = (error: string): void => {
    sendAnalyticsEvent({
      event_category: 'error',
      event_action: actionName,
      event_label: error,
    });
  };

  /**
   * Sends a custom event based on a `name` & `params` property.
   * Used for E-commerce events f.e.
   * @param {Object} obj – a complete payload for custom event.
   * @param {string} obj.name – Name of the event.
   * @param {Object} obj.params – Object containing other props.
   */
  const sendCustom = (obj: CustomData): void => {
    if (
      Object.prototype.hasOwnProperty.call(obj, 'name') &&
      Object.prototype.hasOwnProperty.call(obj, 'params') &&
      Object.keys(obj).length === 2
    ) {
      sendAnalyticsEvent(obj);
    }
  };

  /**
   * Sends a pageview event with custom parameters if provided.
   * Used upon arrival to a page, route or view f.e.
   * Example of `custom` data:
   * { version: '1.2.3', page_type: 'events', local_store: '123' }
   * @param {Object} [custom] – an optional object for the `custom` prop.
   */
  const sendPageview = (custom?: object): void => {
    console.log("sendPageview custom",custom);
    if (!window || !window.location) {
      return;
    }

    const payload: PageViewPayload = {
      // event_category: 'pageview',
      page_path: window.location.pathname || '',
      page_location: window.location.href || '',
    };

    if (custom && Object.keys(custom).length > 0) {
      payload.custom = custom;
    }

    sendAnalyticsEvent(payload);
  };

  return {
    sendCustom,
    sendError,
    sendEvent,
    sendPageview,
  };
}

export default analyticsApiClient;